'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIImage from 'UIComponents/image/UIImage';
import providerSignupImageUrl from 'bender-url!marketplace-assets-base/img/provider-signup/community-creators-image.png';
import providerSignupBlobsUrl from 'bender-url!marketplace-assets-base/img/provider-signup/community-creators-blobs.png';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
import { selectCollectionById } from '../../slices/collections/collectionsSlice';
import { isQa } from '../../utils/env';
import * as ScreenSizes from 'ecosystem-marketplace-core/constants/layout/ScreenSizes';
import { useResponsiveProps } from 'ecosystem-marketplace-core/hooks/useResponsiveProps';
import { H2 } from 'UIComponents/elements/headings';
const SELF_SERVE_CMS_FREE_ID = isQa() ? 1070264 : 556015;

const ProviderSignupBanner = () => {
  const containerRef = useRef(null);
  const leftColumnRef = useRef(null);
  const [compact, setCompact] = useState(false);
  const [containerHeight, setContainerHeight] = useState(0);
  const {
    isMobileView
  } = useResponsiveProps({
    isMobileView: {
      [ScreenSizes.XS]: true,
      [ScreenSizes.SM]: false
    }
  });
  const cmsFreeCollection = useSelector(selectCollectionById(SELF_SERVE_CMS_FREE_ID));
  const buttonUrl = cmsFreeCollection ? `/${cmsFreeCollection.publishedListing.slug}` : '/';
  const {
    trackBeforeUnloadInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const handleSetResponsiveStyles = useCallback(() => {
    if (containerRef.current) {
      if (containerRef.current.clientWidth >= 1100) {
        setCompact(false);
      } else {
        setCompact(true);
      }
    }

    if (leftColumnRef.current) {
      setContainerHeight(leftColumnRef.current.clientHeight);
    }
  }, [containerRef, leftColumnRef]);
  useLayoutEffect(() => {
    window.addEventListener('resize', handleSetResponsiveStyles);
    handleSetResponsiveStyles();
    return () => window.removeEventListener('resize', handleSetResponsiveStyles);
  }, [handleSetResponsiveStyles]);
  const imageStyles = {
    position: 'absolute',
    top: 0,
    right: 'auto'
  };
  const blobStyles = useMemo(() => ({
    position: 'absolute',
    bottom: 0,
    left: compact ? -240 : -312
  }), [compact]);
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "row",
    ref: containerRef,
    style: {
      overflow: 'hidden'
    },
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      className: "m-right-3  p-x-10 p-top-10",
      direction: "column",
      ref: leftColumnRef,
      style: {
        width: '40%',
        paddingBottom: 100
      },
      children: [/*#__PURE__*/_jsx(H2, {
        className: "is--heading-1",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.storefront.providerSignupCTA.title"
        })
      }), /*#__PURE__*/_jsx("span", {
        className: "is--heading-3",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.storefront.providerSignupCTA.subtitle"
        })
      }), /*#__PURE__*/_jsx(UIRouterButton, {
        className: "m-top-4",
        onClick: () => {
          trackBeforeUnloadInteraction('click provider signup');
        },
        to: buttonUrl,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.storefront.providerSignupCTA.button"
        })
      })]
    }), !isMobileView && /*#__PURE__*/_jsxs(UIFlex, {
      style: {
        height: containerHeight,
        position: 'relative',
        width: '50%'
      },
      children: [/*#__PURE__*/_jsx(UIImage, {
        height: containerHeight,
        responsive: false,
        src: providerSignupImageUrl,
        style: imageStyles
      }), /*#__PURE__*/_jsx(UIImage, {
        height: 124,
        responsive: false,
        src: providerSignupBlobsUrl,
        style: blobStyles
      })]
    })]
  });
};

export default ProviderSignupBanner;